// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-ef23c5ea],h3[data-v-ef23c5ea],p[data-v-ef23c5ea]{margin:0;padding:0}.article-block[data-v-ef23c5ea]{margin-block:48px}.article-block[data-v-ef23c5ea] .header,.article-block[data-v-ef23c5ea] h3{font-size:20px;font-weight:900;color:#f7f7f8;margin:16px 0 0}.article-block[data-v-ef23c5ea] .paragraph,.article-block[data-v-ef23c5ea] p{font-size:16px;font-weight:500;line-height:150%;color:#b9bdcc;margin-top:16px}", ""]);
// Exports
module.exports = exports;
